// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHead-root-d08410994a34547db706322115044aa8"};